import { NoDuplicatesTypeArgs } from './duplicate_validation';
import { OneToManyTypeArgs } from './one_to_many_validation';
import { OneToOneTypeArgs } from './one_to_one_validation';
import { IValidationError } from './validations';
import { nestedKeyLookUp } from './../index';

type OneToUnionTypeArgs = OneToManyTypeArgs | OneToOneTypeArgs;
type OneToUnionWithNoDuplicateTypeArgs = OneToUnionTypeArgs | NoDuplicatesTypeArgs;

export class CommonValidationMethods {
  static getSourceTargetKeyMap(sourceKey: string, targetDataConfig: OneToUnionWithNoDuplicateTypeArgs) {
    const targetKey = targetDataConfig.key;
    if (typeof targetKey === 'string') {
      //only One Condition To Match
      return {
        [sourceKey]: targetKey
      };
    }
    return targetDataConfig.key;
  }

  static getFilteredData(sourceData: any, sourceKey: string, targetDataConfig: OneToUnionWithNoDuplicateTypeArgs) {
    const sourceTargetKeyMap = CommonValidationMethods.getSourceTargetKeyMap(sourceKey, targetDataConfig);
    const targetData = targetDataConfig.data;
    if (!sourceTargetKeyMap) {
      // is processing normal array
      const value = sourceData[sourceKey];
      return targetData.filter((data) => data === value);
    }

    const sourceKeys = Object.keys(sourceTargetKeyMap);

    return targetData.filter((targetDataElement) => {
      const targetKey = sourceTargetKeyMap[sourceKey];
      return sourceKeys.every(
        (sourceKey) => nestedKeyLookUp(targetDataElement, targetKey) === nestedKeyLookUp(sourceData, sourceKey)
      );
    });
  }

  static getConditionChecked(sourceData: any, sourceKey: string, targetDataConfig: OneToUnionWithNoDuplicateTypeArgs) {
    const sourceTargetKeyMap = CommonValidationMethods.getSourceTargetKeyMap(sourceKey, targetDataConfig);
    if (!sourceTargetKeyMap) {
      // processing normal array
      return {
        array: targetDataConfig.data,
        valueCheckedForPresence: sourceData[sourceKey]
      };
    }
    const sourceKeys = Object.keys(sourceTargetKeyMap);
    return sourceKeys.reduce((conditionChecked, currentSourceKey) => {
      const targetKey = sourceTargetKeyMap[sourceKey];
      conditionChecked[targetKey] = nestedKeyLookUp(sourceData, currentSourceKey);
      return conditionChecked;
    }, {});
  }

  static isWhiteListedValue(sourceData: any, sourceKey: string, targetDataConfig: OneToUnionWithNoDuplicateTypeArgs) {
    const value = nestedKeyLookUp(sourceData, sourceKey);
    return targetDataConfig.whiteListValueSet && targetDataConfig.whiteListValueSet.has(value);
  }

  static getErrorDetail(
    sourceData: any,
    sourceKey: string,
    targetDataConfig: OneToUnionWithNoDuplicateTypeArgs
  ): Omit<IValidationError, 'type' | 'errorMessage'> {
    const conditionChecked = CommonValidationMethods.getConditionChecked(sourceData, sourceKey, targetDataConfig);
    return {
      sourceTargetKeyMap: CommonValidationMethods.getSourceTargetKeyMap(sourceKey, targetDataConfig),
      sourceObj: sourceData,
      targetObj: targetDataConfig['data'],
      condition: conditionChecked
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/pi-validation/src/validation/common_validation_methods.ts